const TimeZones = [
  {
    label: '(UTC-12:00) International Date Line West',
    value: 'International Date Line West',
  },
  {
    label: '(UTC-11:00) American Samoa',
    value: 'American Samoa',
  },
  {
    label: '(UTC-11:00) Midway Island',
    value: 'Midway Island',
  },
  {
    label: '(UTC-10:00) Hawaii',
    value: 'Hawaii',
  },
  {
    label: '(UTC-09:00) Alaska',
    value: 'Alaska',
  },
  {
    label: '(UTC-08:00) Tijuana',
    value: 'Tijuana',
  },
  {
    label: '(UTC-08:00) Pacific Time (US & Canada)',
    value: 'Pacific Time (US & Canada)',
  },
  {
    label: '(UTC-07:00) Arizona',
    value: 'Arizona',
  },
  {
    label: '(UTC-07:00) Mountain Time (US & Canada)',
    value: 'Mountain Time (US & Canada)',
  },
  {
    label: '(UTC-06:00) Central Time (US & Canada)',
    value: 'Central Time (US & Canada)',
  },
  {
    label: '(UTC-06:00) Saskatchewan',
    value: 'Saskatchewan',
  },
  {
    label: '(UTC-06:00) Guadalajara, Mexico City, Monterey',
    value: 'Mexico City',
  },
  {
    label: '(UTC-05:00) Bogota, Lima, Quito',
    value: 'Bogota',
  },
  {
    label: '(UTC-05:00) Eastern Time (US & Canada), Indiana (East)',
    value: 'Eastern Time (US & Canada)',
  },
  {
    label: '(UTC-04:30) Caracas',
    value: 'Caracas',
  },
  {
    label: '(UTC-04:00) Atlantic Time (Canada)',
    value: 'Atlantic Time (Canada)',
  },
  {
    label: '(UTC-04:00) Georgetown, La Paz, Manaus, San Juan',
    value: 'La Paz',
  },
  {
    label: '(UTC-04:00) Puerto Rico',
    value: 'Puerto Rico',
  },
  {
    label: '(UTC-04:00) Santiago',
    value: 'Santiago',
  },
  {
    label: '(UTC-03:30) Newfoundland',
    value: 'Newfoundland',
  },
  {
    label: '(UTC-03:00) Brasilia',
    value: 'Brasilia',
  },
  {
    label: '(UTC-03:00) Greenland',
    value: 'Greenland',
  },
  {
    label: '(UTC-03:00) Buenos Aires',
    value: 'Buenos Aires',
  },
  {
    label: '(UTC-03:00) Montevideo',
    value: 'Montevideo',
  },
  {
    label: '(UTC-02:00) Mid Atlantic',
    value: 'Mid-Atlantic',
  },
  {
    label: '(UTC-01:00) Cape Verde Is.',
    value: 'Cape Verde Is.',
  },
  {
    label: '(UTC-01:00) Azores',
    value: 'Azores',
  },
  {
    label: '(UTC+00:00) Casablanca',
    value: 'Casablanca',
  },
  {
    label: '(UTC+00:00) Monrovia, Reykjavik',
    value: 'Monrovia',
  },
  {
    label: '(UTC+00:00) Dublin, Edinburgh, Lisbon, London',
    value: 'London',
  },
  {
    label: '(UTC+00:00) Coordinated Universal Time',
    value: 'UTC',
  },
  {
    label: '(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna',
    value: 'Berlin',
  },
  {
    label: '(UTC+01:00) Brussels, Copenhagen, Madrid, Paris',
    value: 'Paris',
  },
  {
    label: '(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague',
    value: 'Budapest',
  },
  {
    label: '(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb',
    value: 'Warsaw',
  },
  {
    label: '(UTC+02:00) Athens, Bucharest, Istanbul',
    value: 'Istanbul',
  },
  {
    label: '(UTC+02:00) Helsinki, Kiev, Riga, Sofia, Tallinn, Vilnius',
    value: 'Helsinki',
  },
  {
    label: '(UTC+02:00) Cairo',
    value: 'Cairo',
  },
  {
    label: '(UTC+02:00) Harare, Pretoria',
    value: 'Harare',
  },
  {
    label: '(UTC+02:00) Jerusalem',
    value: 'Jerusalem',
  },
  {
    label: '(UTC+03:00) Baghdad',
    value: 'Baghdad',
  },
  {
    label: '(UTC+03:00) Minsk',
    value: 'Minsk',
  },
  {
    label: '(UTC+03:00) Kuwait, Riyadh',
    value: 'Riyadh',
  },
  {
    label: '(UTC+03:00) Nairobi',
    value: 'Nairobi',
  },
  {
    label: '(UTC+03:30) Tehran',
    value: 'Tehran',
  },
  {
    label: '(UTC+04:00) Moscow, St. Petersburg, Volgograd',
    value: 'Moscow',
  },
  {
    label: '(UTC+04:00) Tbilisi',
    value: 'Tbilisi',
  },
  {
    label: '(UTC+04:00) Yerevan',
    value: 'Yerevan',
  },
  {
    label: '(UTC+04:00) Abu Dhabi, Muscat',
    value: 'Abu Dhabi',
  },
  {
    label: '(UTC+04:00) Baku',
    value: 'Baku',
  },
  {
    label: '(UTC+04:30) Kabul',
    value: 'Kabul',
  },
  {
    label: '(UTC+05:00) Tashkent',
    value: 'Tashkent',
  },
  {
    label: '(UTC+05:00) Islamabad, Karachi',
    value: 'Karachi',
  },
  {
    label: '(UTC+05:30) Sri Jayawardenepura',
    value: 'Sri Jayawardenepura',
  },
  {
    label: '(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi',
    value: 'Kolkata',
  },
  {
    label: '(UTC+05:45) Kathmandu',
    value: 'Kathmandu',
  },
  {
    label: '(UTC+06:00) Almaty',
    value: 'Almaty',
  },
  {
    label: '(UTC+06:00) Dhaka',
    value: 'Dhaka',
  },
  {
    label: '(UTC+07:00) Bangkok, Hanoi, Jakarta',
    value: 'Bangkok',
  },
  {
    label: '(UTC+07:00) Novosibirsk',
    value: 'Novosibirsk',
  },
  {
    label: '(UTC+08:00) Krasnoyarsk',
    value: 'Krasnoyarsk',
  },
  {
    label: '(UTC+08:00) Ulaanbaatar',
    value: 'Ulaanbaatar',
  },
  {
    label: '(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi',
    value: 'Beijing',
  },
  {
    label: '(UTC+08:00) Perth',
    value: 'Perth',
  },
  {
    label: '(UTC+08:00) Kuala Lumpur, Singapore',
    value: 'Singapore',
  },
  {
    label: '(UTC+08:00) Taipei',
    value: 'Taipei',
  },
  {
    label: '(UTC+09:00) Irkutsk',
    value: 'Irkutsk',
  },
  {
    label: '(UTC+09:00) Seoul',
    value: 'Seoul',
  },
  {
    label: '(UTC+09:00) Osaka, Sapporo, Tokyo',
    value: 'Tokyo',
  },
  {
    label: '(UTC+09:30) Darwin',
    value: 'Darwin',
  },
  {
    label: '(UTC+09:30) Adelaide',
    value: 'Adelaide',
  },
  {
    label: '(UTC+10:00) Hobart',
    value: 'Hobart',
  },
  {
    label: '(UTC+10:00) Yakutsk',
    value: 'Yakutsk',
  },
  {
    label: '(UTC+10:00) Brisbane',
    value: 'Brisbane',
  },
  {
    label: '(UTC+10:00) Guam, Port Moresby',
    value: 'Port Moresby',
  },
  {
    label: '(UTC+10:00) Canberra, Melbourne, Sydney',
    value: 'Sydney',
  },
  {
    label: '(UTC+11:00) Vladivostok',
    value: 'Vladivostok',
  },
  {
    label: '(UTC+11:00) Solomon Islands, New Caledonia',
    value: 'New Caledonia',
  },
  {
    label: '(UTC+12:00) Fiji, Marshall Islands',
    value: 'Fiji',
  },
  {
    label: '(UTC+12:00) Magadan',
    value: 'Magadan',
  },
  {
    label: '(UTC+12:00) Auckland, Wellington',
    value: 'Auckland',
  },
  {
    label: "(UTC+13:00) Nuku'alofa",
    value: "Nuku'alofa",
  },
  {
    label: '(UTC+13:00) Samoa',
    value: 'Samoa',
  },
];

export default TimeZones;
